import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const StyledFiltersBar = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  height: "56px",
  alignItems: "center",
  width: "100%",
  padding: "16px",
  paddingRight: "14px",
  position: "relative",
  borderRadius: "4px",
  marginBottom: "20px",
  boxShadow: "rgba(16, 24, 40, 0.1) 0px 4px 6px",
  userSelect: "none",
}));

export const ToggleContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#fff",
  padding: "12px 0px",
  borderRadius: "4px",
  cursor: "pointer",
}));
